import type { SystemStyleObject } from "@ecco/ui/theme-tools";
import { focusOutline } from "@ecco/ui/css/focus";

export const localCheckboxStyle: SystemStyleObject = {
    fontSize: "14px",
    borderRadius: "100px",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
        ...focusOutline,
        borderRadius: "4px",
        _hover: { outline: "none" },
    },
    _hover: { focus: {} },
};

export const styles = {
    itemWrapper: {
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        alignItems: "center",
        columnGap: 2,
    },
};
